<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-header": "",
        "hide-footer": "",
        id: "edit-payment",
        centered: "",
        size: "md",
      },
      on: { hide: _vm.hideEditPayment },
      model: {
        value: _vm.modalOpen,
        callback: function ($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-ui" },
        [
          _c("div", { staticClass: "rc-modal-title" }, [
            _vm._v(_vm._s(_vm.$t("payment.PaymentMethodDetails"))),
          ]),
          _c("div", { staticClass: "payment-detail-row" }, [
            _c("div", { staticClass: "payment-detail-col" }, [
              _vm._v(" " + _vm._s(_vm.$t("payment.PaymentMethod")) + " "),
            ]),
            _c("div", { staticClass: "payment-detail-col-1" }, [
              _vm._v(_vm._s(_vm.paymentMethodText)),
            ]),
          ]),
          _vm._l(_vm.showData, function (field, index) {
            return field.id !== "qrcode.doc"
              ? _c("div", { key: index, staticClass: "payment-detail-row" }, [
                  _c("div", { staticClass: "payment-detail-col" }, [
                    _vm._v(_vm._s(field.name)),
                  ]),
                  _c("div", { staticClass: "payment-detail-col-1" }, [
                    _vm._v(_vm._s(field.value)),
                  ]),
                ])
              : _vm._e()
          }),
          _c(
            "div",
            { staticClass: "submit-button" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editPaymentMethod(_vm.showData)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("payment.Edit")) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/payment/EditPaymentMethod.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"]
  },
  data() {
    return {
      modalOpen: this.EditPayment // Initialize with the prop value
    };
  },
  watch: {
    EditPayment(newValue) {
      this.modalOpen = newValue; // Update the local state when prop changes
    }
  },
  props: {
    EditPayment: {
      type: Boolean,
      default: false
    },
    hideEditPayment: {
      type: Function,
      default: () => {}
    },
    showData: {
      type: Array,
      default: () => []
    },
    paymentMethodText: {
      type: String,
      default: ""
    },
    editPaymentMethod: {
      type: Function,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/views/payment/EditPaymentMethod.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

